import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

var ErrorComponent = function ErrorComponent(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/React.createElement("div", {
    className: "not-found"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, variant === 'internalServerError' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "500"), /*#__PURE__*/React.createElement("h4", null, "Something went wrong. You could try refreshing the page or looking elsewhere.")), variant === 'notFound' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, "404"), /*#__PURE__*/React.createElement("h4", null, "The page you are looking for is not here.")), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    href: "/"
  }, "Back to Home")))));
};

export var defaultProps = {
  variant: 'internalServerError'
};
export var propTypes = {
  variant: PropTypes.oneOf(['notFound', 'internalServerError']).isRequired
};
ErrorComponent.defaultProps = defaultProps;
export default ErrorComponent;